var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className},[_c('div',{staticClass:"spinner"}),_c('img',{attrs:{"src":require("../../assets/themes/clippFacil/images/imageLoader.png")}}),_c('div',{staticClass:"loader-text"},[_vm._v("Carregando")])])}
var staticRenderFns = []

export { render, staticRenderFns }